// extracted by mini-css-extract-plugin
export default {"NotFoundPage":"_05e8A","content":"Q1IU9","fade-in":"eVFjQ","code":"Xp0rM","homeButton":"FHLWZ","ellipseContainer":"_7V7-d","ellipse":"W2DtB","skeleton-progress":"iVhvg"};